import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { LoyaltyRoutesPath } from '@fcom/loyalty-core';
import { recurseLangParam } from '@fcom/common';

@Injectable()
export class LoyaltyOverhaulGuard implements CanActivate {
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (isPlatformServer(this.platform)) {
      return true;
    }

    const lang = recurseLangParam(route);
    this.router.navigateByUrl(`/${lang}/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.BALANCE_AND_TRANSACTIONS}`, {
      replaceUrl: true,
    });
    return false;
  }
}
